/* https://github.com/soerenmartius/vue3-clipboard */
import { app } from "@/main";
import { VueClipboard } from "@soerenmartius/vue3-clipboard";

app.use(VueClipboard);
